module.exports = __webpack_public_path__ + "static/media/tenstars_negative.f6254759.svg";